import { render } from "./AuthUserForm.vue?vue&type=template&id=0bf61852"
import script from "./AuthUserForm.vue?vue&type=script&lang=js"
export * from "./AuthUserForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__